(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/bankid/components/bankid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/bankid/components/bankid-waiting.js');

'use strict';

const {
  logger
} = svs.playerLogin;
const {
  ReactButton: Button
} = svs.ui;
const {
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const QRCode = svs.components.libs.ReactQRCode;
const {
  bankidProgressStatus,
  appWaitStatus,
  route,
  authMethod
} = svs.playerLogin.constants;
const {
  bankIdLoginMethodChangeAction,
  bankIdBackendStatus
} = svs.playerLogin.store.playerloginreactactions;
const useBankIdPollStatus = svs.playerLogin.bankid.useBankIdPollStatus;

const BankIdWaiting = _ref => {
  let {
    isLogin = true,
    bankIdPollWait = appWaitStatus.WAITING_QRCODE,
    preFetchedAst = null
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const bankIdSsn = ReactRedux.useSelector(state => state.playerloginreact.bankIdSsn);
  let ssn = '';
  if (bankIdPollWait === appWaitStatus.WAITING_SSNAPP) {
    ssn = bankIdSsn;
  }
  const bankIdAutoStartToken = ReactRedux.useSelector(state => state.playerloginreact.autoStartToken);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const history = useHistory();
  const isQrCode = bankIdPollWait === appWaitStatus.WAITING_QRCODE;
  const {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll
  } = useBankIdPollStatus(isQrCode, isLogin, ssn, bankIdAutoStartToken || preFetchedAst);
  const [waitStatus, setWaitStatus] = React.useState(bankidProgressStatus.BEFORE_POLL);

  React.useEffect(() => {
    dispatch(bankIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    if (appUrl && appUrl.length > 5 && bankIdPollWait === appWaitStatus.WAITING_APP && !preFetchedAst) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (svs.core.detect.formfactor.mobile()) {
      logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
      if (isLogin) {
        svs.utils.url.navigate(baseUrl + route.LOGIN_BANKID_START_ROUTE);
      } else {
        svs.utils.url.navigate(baseUrl + route.REGISTRATE_BANKID_START_ROUTE);
      }
    } else if (isLogin) {
      history.push(route.LOGIN_BANKID_START_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_START_ROUTE);
    }
  };
  const onSsnClick = async () => {
    await cancelBackendPoll();
    dispatch(bankIdLoginMethodChangeAction(authMethod.SSN));
    if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_SSN_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_SSN_ROUTE);
    }
  };
  const onOpenBankIdApp = async () => {
    if (appUrl && appUrl.length > 5 && bankIdPollWait === appWaitStatus.WAITING_APP) {
      logger.debug('**** button open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  };
  return React.createElement(React.Fragment, null, waitStatus === bankidProgressStatus.WAITING_APP && bankIdPollWait === appWaitStatus.WAITING_SSNAPP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-8"
  }, "Starta din BankID-app"), React.createElement("div", {
    className: "login-react-margin-top-7 login-react-loader-view-container"
  }, React.createElement(Loader, {
    size: 300
  }))), waitStatus === bankidProgressStatus.WAITING_APP && bankIdPollWait === appWaitStatus.WAITING_APP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "margin-xs-top-2 margin-sm-top-3"
  }, React.createElement("p", null, "Starta din BankID-app")), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: onOpenBankIdApp,
    size: 300
  }, "\xD6ppna BankID appen")), React.createElement("div", {
    className: "margin-xs-top-1"
  }, "Startar inte BankID-appen?"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: onSsnClick,
    size: 300
  }, "Ange personnummer"))), (waitStatus === bankidProgressStatus.BEFORE_POLL || waitStatus === bankidProgressStatus.SHOWING_QRCODE || waitStatus === bankidProgressStatus.ERROR_POLL) && bankIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "margin-md-top-4"
  }, React.createElement("div", {
    className: "login-react-qrcode"
  }, qrCode && React.createElement(QRCode, {
    className: "margin-xs-top",
    size: 120,
    value: qrCode
  }))), React.createElement("div", {
    className: "margin-xs-top-2"
  }, "Starta BankID-appen p\xE5 din mobil eller surfplatta. Klicka p\xE5 QR-ikonen och l\xE4s av QR-koden ovan med kameran."), React.createElement("div", {
    className: "login-react-margin-top-5"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: onSsnClick,
    size: 300,
    transparent: true
  }, "Logga in med personnummer"))), (waitStatus === bankidProgressStatus.SHOWING_SPINNER || waitStatus === bankidProgressStatus.NEW_CUSTOMER || waitStatus === bankidProgressStatus.RETAIL_CUSTOMER || waitStatus === bankidProgressStatus.ONLINE_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-8"
  }, waitStatus === bankidProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "login-react-margin-top-7 login-react-loader-view-container"
  }, React.createElement(Loader, {
    size: 300
  }))), React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLogin.bankid.components.BankIdWaiting = BankIdWaiting;

 })(window);